export default class List {
  constructor(obj) {
    this.listName = obj.listname;
    this.id = obj.id;
    this.info = obj.list;
    this.created_at = obj.created_at;
    this.updated_at = obj.updated_at;
  }
}
